/* Kasutam theme — hero slideshow: autoplay, arrows, dots, pause on interaction */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-slideshow]').forEach(function (root) {
      var slides = root.querySelectorAll('.hero-slideshow__slide');
      if (slides.length < 2) return;

      var dots = root.querySelectorAll('[data-slide-dot]');
      var prevBtn = root.querySelector('[data-slide-prev]');
      var nextBtn = root.querySelector('[data-slide-next]');
      var current = 0;
      var timer = null;
      var speed = Number(root.dataset.speed) || 6000;
      var autoplay = root.dataset.autoplay === 'true';
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // ── Touch swipe support ──────────────────────────────────────
      var touchStartX = 0;
      var touchStartY = 0;
      var touchDeltaX = 0;
      var isSwiping = false;
      var SWIPE_THRESHOLD = 40; // px — minimum horizontal drag to count as swipe

      root.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchDeltaX = 0;
        isSwiping = false;
        stop(); // pause autoplay while user is touching
      }, { passive: true });

      root.addEventListener('touchmove', function (e) {
        var dx = e.touches[0].clientX - touchStartX;
        var dy = e.touches[0].clientY - touchStartY;

        // If scrolling vertically, don't hijack the scroll
        if (!isSwiping && Math.abs(dy) > Math.abs(dx)) return;

        isSwiping = true;
        touchDeltaX = dx;
        e.preventDefault(); // prevent page scroll while swiping slider
      }, { passive: false });

      root.addEventListener('touchend', function () {
        if (!isSwiping) { start(); return; }

        if (touchDeltaX < -SWIPE_THRESHOLD) {
          next(); // swiped left → next slide
        } else if (touchDeltaX > SWIPE_THRESHOLD) {
          prev(); // swiped right → prev slide
        }

        isSwiping = false;
        touchDeltaX = 0;
        start(); // resume autoplay
      }, { passive: true });
      // ────────────────────────────────────────────────────────────

      function show(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === current);
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === current);
        });
      }

      function next() { show(current + 1); }
      function prev() { show(current - 1); }

      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }
      function start() {
        if (!autoplay || reduceMotion) return;
        stop();
        timer = setInterval(next, speed);
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { show(i); start(); });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);

      start();
    });
  });
})();